export default __webpack_public_path__ + "static/media/SVT.4b6b5ae1.png";